var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3;
var _react_refresh_temp_4;
_react_refresh_temp_4 = $RefreshSig$();
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Tab } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { createSelector } from '@reduxjs/toolkit';
import ParticipantsComponent from '../participants';
import PollsComponent from '../polls';
import { useGetPollsStatsQuery } from '../../store/services/pollsApi';
import { store, useAppDispatch, useAppSelector } from '../../store';
import { updateSelectedTabLeftPanel } from '../../store/slices/roomSettingsSlice';
import { useGetMyBreakoutRoomsQuery } from '../../store/services/breakoutRoomApi';
import MyBreakoutRooms from '../breakout-room/my/myBreakoutRooms';
import { updateIsActiveParticipantsPanel } from '../../store/slices/bottomIconsActivitySlice';
const selectedTabLeftPanelSelector = createSelector(_react_refresh_temp_1 = (state) => state.roomSettings, (roomSettings) => roomSettings.selectedTabLeftPanel);
$RefreshReg$(_react_refresh_temp_1, "selectedTabLeftPanelSelector$createSelector");
const LeftPanel = () => {
    var _a;
    _react_refresh_temp_4();
    const { data } = useGetPollsStatsQuery();
    const { data: myRooms } = useGetMyBreakoutRoomsQuery();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const allow_polls = (_a = store.getState().session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features.allow_polls;
    const selectedTabLeftPanel = useAppSelector(selectedTabLeftPanelSelector);
    const items = useMemo(() => {
        var _a, _b;
        const total_running = (_b = Number((_a = data === null || data === void 0 ? void 0 : data.stats) === null || _a === void 0 ? void 0 : _a.totalRunning)) !== null && _b !== void 0 ? _b : 0;
        const items = [
            {
                id: 1,
                title: _jsx(_Fragment, { children: t('left-panel.participants-tab') }),
                elm: _jsx(ParticipantsComponent, {}),
            },
        ];
        if (allow_polls) {
            items.push({
                id: 2,
                title: (_jsxs(_Fragment, { children: [t('left-panel.polls-tab'), total_running > 0 ? (_jsx("span", { className: "absolute ltr:-right-5 rtl:-left-5 -top-[7px] w-5 h-5 bg-primaryColor rounded-full text-white text-[10px]", children: total_running !== null && total_running !== void 0 ? total_running : 0 })) : null] })),
                elm: _jsx(PollsComponent, {}),
            });
        }
        if (myRooms === null || myRooms === void 0 ? void 0 : myRooms.status) {
            items.push({
                id: 3,
                title: _jsx(_Fragment, { children: t('left-panel.breakout-room-tab') }),
                elm: _jsx(MyBreakoutRooms, {}),
            });
        }
        return items;
    }, [data, myRooms]);
    const changeTabIndex = (i) => {
        dispatch(updateSelectedTabLeftPanel(i));
    };
    const classNames = (...classes) => {
        return classes.filter(Boolean).join(' ');
    };
    const closePanel = () => {
        dispatch(updateIsActiveParticipantsPanel(false));
    };
    return (_jsxs("div", { id: "main-left-panel", className: "participants-wrapper relative z-10 left-0 top-0 h-full w-[330px] multi-gradient", children: [_jsxs("div", { className: "hidden md:inline-block close absolute z-10 -right-[14px] top-1 w-6 h-6 rounded-full border border-solid border-primaryColor dark:border-darkText bg-white dark:bg-darkPrimary cursor-pointer", onClick: closePanel, children: [_jsx("span", { className: "inline-block w-[18px] h-[1px] bg-primaryColor dark:bg-darkText absolute rotate-45 top-[11px] left-[2px]" }), _jsx("span", { className: "inline-block w-[18px] h-[1px] bg-primaryColor dark:bg-darkText absolute -rotate-45 top-[11px] right-[2px]" })] }), _jsxs(Tab.Group, { vertical: true, selectedIndex: selectedTabLeftPanel, onChange: changeTabIndex, children: [_jsx(Tab.List, { className: "flex", children: items.map((item) => (_jsx(Tab, { className: ({ selected }) => classNames('w-full py-2 text-xs text-black dark:text-white font-bold leading-5 border-b-4 border-solid transition ease-in', selected ? 'border-[#004d90]' : 'border-[#004d90]/20'), children: _jsx("div", { className: "name relative inline-block", children: item.title }) }, item.id))) }), _jsx(Tab.Panels, { className: "relative h-[calc(100%-45px)]", children: items.map((item) => (_jsx(Tab.Panel, { className: `${item.id === 2 || item.id === 3
                                ? 'polls h-full'
                                : 'px-2 xl:px-4 pt-2 xl:pt-5 h-full'}`, children: _jsx(_Fragment, { children: item.elm }) }, item.id))) })] })] }));
};
_react_refresh_temp_2 = LeftPanel;
$RefreshReg$(_react_refresh_temp_2, "LeftPanel");
_react_refresh_temp_4(LeftPanel, "/5w/D6JU4zFuhVyacB/AAVEts1w=", false, () => [useGetPollsStatsQuery, useGetMyBreakoutRoomsQuery, useTranslation, useAppDispatch, useAppSelector]);
export default _react_refresh_temp_3 = React.memo(LeftPanel);
$RefreshReg$(_react_refresh_temp_3, "%default%");
